import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  UpdateTaskMutation,
  UpdateTaskMutationVariables,
  UpdateTaskDocument,
  FetchTasksByTenderIdDocument,
} from "@/graphql/__generated__/graphql";

export default function useUpdateTaskMutationHook(): {
  updateTaskMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [updateTaskMutation, { loading, error }] = useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(
    UpdateTaskDocument, {
      onCompleted: () => {
        toast(CustomToastComponent, {
          toastId: "task-update-success",
          data: {
            title: t("toasts.taskupdated"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: FetchTasksByTenderIdDocument,
          variables: { tenderId: Number(tenderID) },
        },
      ],
    });

  return {
    updateTaskMutation,
    loading,
    error,
  };
}
